/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc
 */

export let ComHubspotBuyingModelsRpcDtb;
(function (_ComHubspotBuyingModelsRpcDtb) {})(ComHubspotBuyingModelsRpcDtb || (ComHubspotBuyingModelsRpcDtb = {}));
export let ComHubspotBuyingModelsRpcDtbChirp;
(function (_ComHubspotBuyingModelsRpcDtbChirp) {})(ComHubspotBuyingModelsRpcDtbChirp || (ComHubspotBuyingModelsRpcDtbChirp = {}));
export let ComHubspotBuyingModelsRpcDtbChirpV2;
(function (_ComHubspotBuyingModelsRpcDtbChirpV) {})(ComHubspotBuyingModelsRpcDtbChirpV2 || (ComHubspotBuyingModelsRpcDtbChirpV2 = {}));
/**
 *  Request model for purchasing parent products.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
/**
 *  Request model for purchasing quantity packs.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export const createDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'BE1JNQY91cyHfqUStZAqMpwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createDirectToBuyConfigV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfigV2',
  auth: 'external',
  fingerprint: 'zQRL67kZOeeHfqUStZAqMphL_Uso95rB',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createDirectToBuyConfigWithIdRpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfigWithId',
  auth: 'external',
  fingerprint: 'pbDQBYOJg1-HfqUStZAqMpwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.na1.PublicDirectToBuyRpc',
  rpcName: 'getDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'RwkVwEpJCiYLSzQQ55nir5wP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};